export default {
  VERSION: '0.0.01',
  MAYA_API: 'https://api-staging.maya.tech/otc',
  DEFAULT_LANGUAGE: 'en_US',
  SUPPORT_NUMBER: '+1 (855) 781-7277',
  STATIC_PATH: 'https://atm.cm',
  // Timeouts (in seconds)
  TIMEOUT: 1500,
  INTERNAL_TIMEOUT: 300,
  SCANNER_URL: 'http://localhost:8009'
};


// WEBPACK FOOTER //
// ./src/config/dev.js